/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Macos_3Inputs */

const en_pc_dl_macos_3 = /** @type {(inputs: Pc_Dl_Macos_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app is signed and notarized by Apple, so it opens normally on first launch. Drop a PDF on the window to start.`)
};

const zh_pc_dl_macos_3 = /** @type {(inputs: Pc_Dl_Macos_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用经过 Apple 签名和公证，首次启动即可正常打开。把 PDF 拖进窗口即可开始。`)
};

/**
* | output |
* | --- |
* | "The app is signed and notarized by Apple, so it opens normally on first launch. Drop a PDF on the window to start." |
*
* @param {Pc_Dl_Macos_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_macos_3 = /** @type {((inputs?: Pc_Dl_Macos_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Macos_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_macos_3(inputs)
	return zh_pc_dl_macos_3(inputs)
});
export { pc_dl_macos_3 as "pc.dl.macos.3" }